import './new-hco.css';
import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useHistory, withRouter } from 'react-router-dom'
import ProgressBar from '../progress/progressBar';
import { Accordion, AccordionDetails, AccordionSummary, Alert, Autocomplete, Button, Card, CardContent, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { ArrowBack, Edit, ExpandMore, Save } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab'
import { DirectionContext } from '../../context/DirectionProvider';
import Storage from '../../session/storage';
import jsondata from '../../config/NewHCOFormFields.json';
import api from '../../service/api';
// import * as countryStates from '../../config/country_state_province.json'
import IdentifiersView from '../detail-page/input/identifiers-view';
import CONSTANT from '../../Constant/Constant';
import Popup from '../detail-page/error/popup';
import filter from '../../service/filter';
import ConfirmationDialogRaw1 from '../globalSearch/popupGlobal';
import useLocalStorage from '../../hooks/useLocalStorage';
import { sortTranslated } from '../shared/util';

function AddNewHCOUS(props) {
  const direction = useContext(DirectionContext);
  const location = useLocation();
  const history = useHistory();

  const [modal, setModal] = useState({ flag: false });
  const [showModal, setShowModal] = useState(true)
  const [closeSpecialtyPopup, setCloseSpecialtyPopup] = useState(false)
  const [loading, setLoading] = useState(true);
  const [specialties, setSpecialties] = useState([]);
  const [accordianState, setAccordianState] = useState({});
   const [selectedCountryForDcr, setSelectedCountryForDcr] = useState()
  // true if no state passed, assuming that specialty is not selected or coming to this page directly typing the address or from vendor search
  const [editPopupState, setEditPopupState] = useState(props.location.state ? false : true);
  const [identifierAddFormOpen, setIdentifierAddFormOpen] = useState(false);


  let fieldSections = []
  try {
    fieldSections = jsondata['countries'].find(item => item.country_Name === 'United States').input.iqvia
  } catch (err) {
    console.log("Error getting fieldSections from NewHCPFormFields.json", err)
  }

  const initialValues = {
    country: location.state && location.state.country ? location.state.country : "United States",
    source: location.state && location.state.source ? location.state.source : "IQVIA_US",
    primarySpecialty: location.state && location.state.newSpecialty && location.state.newSpecialty.PrimarySpecialty ? location.state.newSpecialty.PrimarySpecialty[0].value : null,
    otherSpecialty: location.state && location.state.newSpecialty && location.state.newSpecialty.OtherSpecialty ? location.state.newSpecialty.OtherSpecialty[0].value : [],

    hcoObj: null, // for autocomplete
    hcoNameSearch: null, // for autocomplete seach input
    identifiers: [], // for identifiers
  }

  for (const section in fieldSections) {
    initialValues[fieldSections[section]['id']] = {}

    for (const attribute of fieldSections[section].attributes) {
      initialValues[fieldSections[section]['id']][attribute['id']] = attribute['value']
    }
  }

  const [data, setData] = useState(initialValues)
  const [editPopupData, setEditPopupData] = useState({})
  const [langLocaleChange] = useLocalStorage('wglang_api')

  useEffect(() => {
    // things I need to do once.
    setLoading(true); 
    api.getPickList(data.country, undefined, undefined, undefined, undefined, langLocaleChange).then(({ data: rdmData }) => {
      Storage.setLovBoundedList(filter.mapPickList(rdmData[0]))
      // setDropdownOptions({
      //   ...dropdownOptions,
      //   'Title': rdmData[0].title_vn,
      //   'Classification': rdmData[0].clsfctn,
      //   'StateProvince': countryStates['United States'],
      //   'identifierOptions': Array.from(new Set(rdmData[0].altrnt_id_typ))
      //   // 'altrnt_id_subtyp_vn': rdmData[0].altrnt_id_subtyp_vn,
      // })
      setSpecialties(rdmData[0]['HCO'].spclty)
      setShowModal(false)
    }).catch((err) => {
       console.log("getPickList err", err)
    }).finally(() => {
      setLoading(false);
    })

    //on component update

    const updatedValues  = {
      country: location.state && location.state.country ? location.state.country : "United States",
      source: location.state && location.state.source ? location.state.source : "IQVIA_US",
      primarySpecialty: location.state && location.state.newSpecialty && location.state.newSpecialty.PrimarySpecialty ? location.state.newSpecialty.PrimarySpecialty[0].value : null,
      otherSpecialty: location.state && location.state.newSpecialty && location.state.newSpecialty.OtherSpecialty ? location.state.newSpecialty.OtherSpecialty[0].value : [],
  
      hcoObj: null, // for autocomplete
      hcoNameSearch: null, // for autocomplete seach input
      identifiers: [], // for identifiers
    }
  
    for (const section in fieldSections) {
      updatedValues[fieldSections[section]['id']] = {}
  
      for (const attribute of fieldSections[section].attributes) {
        updatedValues[fieldSections[section]['id']][attribute['id']] = attribute['value']
      }
    }

    setData(updatedValues)

  }, [location.state.country, location.state.source, location.state.newSpecialty, langLocaleChange]);




  const editBtn = () => {
    setCloseSpecialtyPopup(true)
    setEditPopupState(true);
    setEditPopupData({
      primarySpecialty: data.primarySpecialty,
      otherSpecialty: data.otherSpecialty ? data.otherSpecialty : []
    })
  }

  const alertMsg = (msg) => {
    setModal({ flag: true, success: false, message: msg, title: 'Error' })
  }

  // const editPopupOKbtn = () => {
  //   setEditPopupState(false);
  //   setData({ ...data, primarySpecialty: editPopupData.primarySpecialty, otherSpecialty: editPopupData.otherSpecialty })
  // }

  const clearFormBtn = () => {

    setData({
      ...initialValues,
      country: data.country,
      source: data.source,
      primarySpecialty: data.primarySpecialty,
      otherSpecialty: data.otherSpecialty
    })
  }

  const [HCORequest, setHCORequest] = useState(CONSTANT.NEW_HCO_BODY)
  const requestFormBtn = () => {
    const payload = Object.assign({}, HCORequest);
    // validating, if all required fields are filled in

    if (identifierAddFormOpen === true) {
      alertMsg("Please save the identifier first")
      return
    }

    for (const section of fieldSections) {
      // skip address validation if existing HCO selected
      if (data.hcoObj && data.hcoObj._id && section.id === 'Address') {
        continue
      }

      for (const attribute of section.attributes) {
        if (attribute.required && (!data[section.id] || !data[section.id][attribute.id])) {
          alertMsg("Please fill in all required fields")
          return
        }
      }
    }

    try {
      payload.entity.Source[0].value = data.source
    } catch (err) {
       console.log("requestFormBtn error", err)
    }

    try {
      payload.entity.CountryCode = [{ value: data.country }]
    } catch (err) {
       console.log("requestFormBtn error", err)
    }

    try {
      payload.entity.NewSpecialities = {
        PrimarySpecialty: [{ value: data.primarySpecialty }],
        OtherSpecialty: [{ value: data.otherSpecialty }]
      }
    } catch (err) {
      console.log("requestFormBtn error", err)
    }

    // {
    //   "PrimarySpecialty": [
    //     {
    //       "value": "ABDOMINAL / DIGESTIVE SURGERY | S001"
    //     }
    //   ],
    //     "OtherSpecialty": [
    //       {
    //         "value": [
    //           "ABORIGINAL HEALTH | S002",
    //           "ABDOMINAL SURGERY | S682"
    //         ]
    //       }
    //     ]
    // }

    let fieldKeys = []
    // from mainInfo
    fieldKeys = ["Name", "ClassificationCode"]
    for (const key of fieldKeys) {
      if (!data['mainInfo'][key]) {
        continue
      }
      try {
        payload.entity[key] = [{ value: data['mainInfo'][key] }]
      } catch (err) {
        console.log("requestFormBtn error", err)
      }
    }

    // address
    fieldKeys = ["AddressLine1", "AddressLine2", "City", "Zip", "StateProvince"]
    const address = {}
    for (const key of fieldKeys) {
      if (!data['address'][key]) {
        continue
      }
      try {
        address[key] = [{ value: data['address'][key].code ? data['address'][key].code : data['address'][key] }]
      } catch (err) {
        console.log("requestFormBtn error", err)
      }
    }

    if (Object.keys(address).length > 0) {
      payload.entity['Address'] = [address]
    }

    if (data.identifiers) {
      payload.entity.NewIdentifiers = data.identifiers
    }

    // new hco - relation
    payload.relations = []
    payload['RelationTo'] = data.source
    payload['vendor'] = data.source

    setHCORequest(payload)
    // open popup for comment
    setConfirmDialogState({ ...confirmDialogState, open: true })
  }

  // const toProperCase = (string) => {
  //   return string
  //     .toLowerCase()  // Convert the entire string to lowercase first
  //     .split(/(\W+)/) // Split by non-word characters
  //     .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter
  //     .join('');  // Rejoin the string parts
  // }



  const renderAccordian = (section) => {
    return <Accordion key={section.id} className=" shadow-md" expanded={!accordianState[section.id]}>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id={section.id}
        onClick={() => setAccordianState({ ...accordianState, [section.id]: !accordianState[section.id] })}>
        <Typography id='newhcp-text'>
          {section.heading}
        </Typography>
      </AccordionSummary>

      <AccordionDetails>
        <div className="row container w-100 p-3 pt-0">
          {section.attributes.sort((a, b) => { return a.order - b.order }).map((attribute, key) => renderAccordianDetails(section, attribute, key))}
        </div>
      </AccordionDetails>
    </Accordion>
  }

  const renderAccordianDetails = (section, attribute, key) => {
    const options = (attribute.lookup && Storage.getLovBoundedList()['HCO'][attribute.lookup]) ? attribute.lookup && Storage.getLovBoundedList()['HCO'][attribute.lookup] : []

    return (<div key={key} className='col-sm-12 col-md-6' style={{ paddingBottom: 10 }}>
      <span id="newhcp-text">{attribute.name}</span>
      {attribute.required && <span className='required-asterisk-exclusion'> *</span>}
      {attribute.element === 'select' &&
        <Autocomplete
          id={`${section.id}.${attribute.id}`}
          name={`${section.id}.${attribute.id}`}
          value={data[section.id][attribute.id]}
          onChange={(event, value) => {
            setData({
              ...data,
              [section.id]: {
                ...data[section.id],
                [attribute.id]: value?.split('//')[0].length > 0 
                ? value.split('//')[0] 
                : value 
              }
            })
          }}
          options={options.flatMap(group => group.options ? sortTranslated(group.options) : group )}
          getOptionLabel={(option) => option.split('//')[0]}
          groupBy={(option) => {return option.includes('//UnClassified') ? 'Unclassified' :`HCO - ${attribute.name}` }}
          onBlur={() => {
            setDirty({
              ...dirty,
              [`${section.id}.${attribute.id}`]: true
            })
          }}
          isOptionEqualToValue={(option, value) => option === value}
          multiple={attribute.multi}
          renderInput={(params) =>
            <TextField {...params}
              error={(dirty[`${section.id}.${attribute.id}`] && attribute.required && !data[section.id][attribute.id])}
              helperText={(dirty[`${section.id}.${attribute.id}`] && attribute.required && !data[section.id][attribute.id]) ? "Please Select One Option" : ''}
              variant="standard" id="varantOptionTxT" />}
        />}

      {attribute.element === 'input' && <TextField
        // value={data[attribute.id] ? data[attribute.id] : null}
        id={attribute.id}
        name={`${section.id}.${attribute.id}`}
        value={data[section.id][attribute.id]}

        type={attribute.type}
        required={attribute.required}
        // key={'label'}
        onBlur={() => {
          setDirty({
            ...dirty,
            [`${section.id}.${attribute.id}`]: true
          })
        }}
        error={dirty[`${section.id}.${attribute.id}`] && attribute.required && !data[section.id][attribute.id]}
        helperText={(dirty[`${section.id}.${attribute.id}`] && attribute.required && !data[section.id][attribute.id]) ? 'Please enter a value' : ''}
        onChange={(event) => {
          setData({
            ...data,
            [section.id]: {
              ...data[section.id],
              [attribute.id]: event.target.value
            }
          })
        }}
        // onBlur={passToParent}
        variant="standard"
        color="primary"
        className="w-100 input-text" />
      }
    </div>)
  }

  const renderIdentifiers = () => {
    return <>
      <IdentifiersView
        addFlag={"HCP"}
        identifierOptions={Storage.getLovBoundedList()['HCO']['AltIDType']}
        mode={'Edit'}
        change={'changeCompleted'}
        error={true}
        label={"Identifier"}
        updatedValue={(newValue, flag) => {
          // close the identifier form
          setIdentifierAddFormOpen(false)
          setData({
            ...data,
            identifiers: newValue
          })
        }}
        heading={'Type&ID'}
        value={data.identifiers}
        checkIdentifierSubmitted={(addflag, identifierType, identifierId, identifierSaved) => {
          // addflag = true -> indetifier form is open with Save/Cancel button.
          if (identifierSaved) {
            setIdentifierAddFormOpen(false)
          } else {
            setIdentifierAddFormOpen(addflag)
          }
        }}
        submit={false}
        shadow={true}
        vendor={data.source}
        entity ={'HCP'}
      />
    </>
  }


  const [confirmDialogState, setConfirmDialogState] = useState({
    submitFlag: false,
    open: false,
    comment: '',
    submitStatus: null,
    submitResponse: null
  })

  const [dirty, setDirty] = useState({})
  const renderConfirmDialog = () => {
    return <Dialog
      onClose={confirmDialogCloseBtn}
      open={confirmDialogState.open}
      aria-labelledby="contentIdbox"
      aria-describedby="contentIdboxdes"
      fullWidth
      maxWidth="xs">
      <DialogTitle id="DialogTxtbox" color='primary' className='fw-bold'>Submit Request</DialogTitle>
      <DialogContent id="contentIdbox">
        {/* <center><CheckCircleRounded className='success' /></center> */}
        {/* <center><Cancel className='secondary' /></center> : */}
        <DialogContentText id="contentIdboxdes">
          {confirmDialogState.submitStatus &&
            <React.Fragment>
              {confirmDialogState.submitStatus === 200 && <>
                <Alert severity="success">
                  Your request is submitted for processing. You will receive an email notification on successful submission or in case of any failure.
                  {/*  Your request is submitted for processing. 
                  This DCR will be routed to IQVIA_US.<br/>
                  {confirmDialogState.submitResponse && Array.isArray(confirmDialogState.submitResponse) && confirmDialogState.submitResponse.map((item, index) => (
                    <span key={index}>#{item.change_request_id}{index<confirmDialogState.submitResponse.length - 1? ", " : ""}</span>
                  ))}<br/>
                  You will receive an email notification on successful submission or in case of any failure. */}
                </Alert>
              </>}
              {confirmDialogState.submitStatus !== 200 && <>
                <Alert severity="error">
                  Unable to fullfill your request due to some technical issue.
                  Please try again later.
                  If this still doesn't work then please reach out to the ECS operations team by raising an incident to ENTPROFHUB-GSSIT-GLB on Service Now.
                </Alert>
              </>}
            </React.Fragment>}
          {/* <pre>{JSON.stringify(confirmDialogState, null, 4)}</pre> */}
        </DialogContentText>

        {confirmDialogState.submitStatus !== 200 && <>
          <Typography
            color="neutral"
            level="title-md"
            variant="plain">
            Comments *
          </Typography>

          <TextField
            value={confirmDialogState.comment}
            className='w-100'
            onChange={(event) => setConfirmDialogState({ ...confirmDialogState, comment: event.target.value })}
            multiline
            rows={3}
            variant="outlined"
            error={!!!confirmDialogState.comment}
            helperText={confirmDialogState.comment ? '' : "Comment is required"}
          />
        </>}
      </DialogContent>

      <DialogActions sx={{ mr: '15px' }} id="dialog-action">
        <Button onClick={confirmDialogCloseBtn} color="error" variant="outlined" disabled={confirmDialogState.submitFlag}>
          {confirmDialogState.submitStatus == 200 ? 'Confirm' : 'Close'}
        </Button>

        {confirmDialogState.submitStatus !== 200 && <>
          <LoadingButton
            onClick={confirmDialogSubmitBtn}
            loading={confirmDialogState.submitFlag}
            loadingPosition="start"
            startIcon={<Save />}
            color="error"
            variant="contained"
            disabled={confirmDialogState.submitFlag || confirmDialogState.comment.trim() === ''}>
            Submit
          </LoadingButton>
        </>}
      </DialogActions>
    </Dialog>
  }
  const confirmDialogSubmitBtn = () => {
    setConfirmDialogState({ ...confirmDialogState, submitFlag: true })

    const updatedValue = HCORequest
    updatedValue.comment = confirmDialogState.comment

    /**
     * Test with mock response
  new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({
        "status": 200,
        "data": [
            {
              "status": true,
              "change_request_id": "LLY_DCR_US_1778447c126f4f73b2f99",
              "vendor": "EPH"
            },
            {
              "status": true,
              "change_request_id": "LLY_DCR_US_1778447c126f4f73b2100",
              "vendor": "EPH"
            }
          ]
      })

      // reject({
      //   'response': {
      //   "status": 201,
      //   "data": [
      //       {
      //         "status": true,
      //         "change_request_id": "LLY_DCR_US_1778447c126f4f73b2f99",
      //         "vendor": "EPH"
      //       }
      //     ]
      //   }
      // })
    }, 2000)
  }).then(response => {
      setConfirmDialogState({
        ...confirmDialogState,
        submitFlag: false,
        submitStatus: response.status,
        submitResponse: response.data
      })
    }).catch(err => {
      setConfirmDialogState({
        ...confirmDialogState,
        submitFlag: false,
        submitStatus: err.response.status,
        submitResponse: err.response.data
      })
    }).finally(() => {
    })
      */

    api.postUpdate(updatedValue, {}).then(response => {
      setConfirmDialogState({
        ...confirmDialogState,
        submitStatus: response.status,
        submitResponse: response.data
      })
    }).catch(err => {
      console.log("postUpdate err", err)
      setConfirmDialogState({
        ...confirmDialogState,
        submitStatus: err.response.status,
        submitResponse: err.response.data
      })
    })
  }

  //dynamic pop
  const closePopup= () =>{
    if(showModal){
        setShowModal(false)
    }
    else{
        setCloseSpecialtyPopup(false)
    }        
  }

  const confirmDialogCloseBtn = () => {
    setConfirmDialogState({
      ...confirmDialogState,
      open: false,
      comment: '',
      submitStatus: null,
      submitResponse: null
    })
    if (confirmDialogState.submitStatus == 200) {
      history.push('/track-request')
    }
  }

  // function handleOk(value) {
  //   setSelectedCountryForDcr(value)
  //   // this.setState({showIqviaPopUp:false, noAccess:false, showAccessPop: false, selectedCountryForDcr: value})
  // };

  // function cancelPopUp(){
  //     // this.setState({showIqviaPopUp:false, showNewHcoPopUp: false, noAccess:false, showAccessPop: false, selectedCountryForDcr: ''})
  //     setSelectedCountryForDcr(data.country)
  //   }
  return (
    <div className='body-height' style={{ paddingBottom: 60 }}>
      {loading && <div className="extra-margin-top d-flex justify-content-center body-height">
        <ProgressBar />
      </div>}

      

      
      {closeSpecialtyPopup && !loading && <ConfirmationDialogRaw1
                    open={closeSpecialtyPopup}
                    option={Storage.getAllCountryList()}
                    entityType={'HCO'}
                    selectedCountry = {location.state.country}
                    SelectedSpecialtyValue = {location.state.newSpecialty}
                    allSelectedSpecialty = {location.state.allSelectedSpecialty}
                    primarySpecialty = {location.state.primarySpecialty}
                    otherSpecialty = {location.state.otherSpecialty}
                    onOk={closePopup}
                    onCancel={closePopup}
                    user= {props.user}
                    entity="HCO"
                
                />}

      {!loading && <div className="extra-margin-top-less container w-80 body-height min-width">
        <Stack
          direction='row'
          justifyContent="flex-start"
          alignItems='center'
          gap={1}>
          <Tooltip disableFocusListener title="Back" id='tltipStrictSearchChckbx'>
            <IconButton aria-label="delete"
              onClick={() => {
                props.history.push('/')
              }}
              className="text-danger float-end"
              color="secondary">
              <ArrowBack
                sx={{ transform: direction === 'rtl' ? 'rotate(180deg)' : '' }} />
            </IconButton>
          </Tooltip>
          <Typography variant="h1" margin={0} style={{ fontSize: 21 }} id="newhcp-text">
            HCO Details
          </Typography>
        </Stack>


        <Card className='p-0 mb-3 mt-2'>
          <IconButton aria-label="delete"
            onClick={editBtn}
            sx={{ float: 'right', marginLeft: '30px' }}>
            <Tooltip disableFocusListener title="Edit details   " id="tooltip" >
              <Edit sx={{ transform: direction === 'rtl' ? 'rotate(180deg)' : '' }} />
            </Tooltip>
          </IconButton>


          <CardContent className='p-2'>
            <Stack
              direction='row'
              justifyContent={'space-between'}
              alignItems='center'
              flexWrap={'wrap'}
              className='p-0 m-0'
            >
              <Typography variant='p' margin={0} id='newhcp-text'>
                <span className="text-muted">Country: </span>
                <span className='_wg-exclude'>{data.country} </span>
              </Typography>
              <Typography variant='p' margin={0} id='newhcp-text'>
                <span className="text-muted">Source: </span>
                <span className='_wg-exclude'>{data.source}</span>
              </Typography>
              <Typography variant='p' margin={0} id='newhcp-text'>
                <span className="text-muted">Primary Specialty: </span>
                <span className='_wg-exclude'>{data.primarySpecialty ? data.primarySpecialty : <span style={{ color: '#d32f2f' }}>Please select</span>}</span>
              </Typography>
              {data.otherSpecialty && data.otherSpecialty.length > 0 &&
                <Typography variant='p' margin={0} id='newhcp-text'>
                  <span className="text-muted">Other Specialities:</span>
                  {
                    data.otherSpecialty.map((res, key) => {
                      return (
                        <Chip className='_wg-exclude' key={key} label={res} size="small" sx={{ marginLeft: '5px' }} />
                      )
                    })
                  }
                </Typography>
              }
            </Stack>
          </CardContent>
        </Card>

        {/* Render all sections from json config file */}
        {fieldSections.filter(item => item.id !== 'Address').map((section) => renderAccordian(section))}

        {renderIdentifiers()}

        <DialogActions className="d-flex justify-content-center mt-4 mb-3" id="newhcp-button" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button className="btn btn-secondry border clearall" onClick={clearFormBtn} color="error" variant="outlined">
            CLEAR ALL
          </Button>
          <Button className="btn btn-secondry border request" onClick={requestFormBtn} color="error" variant="contained">
            REQUEST
          </Button>
        </DialogActions>
      </div>}


      {
        modal.flag && (
          <Popup
            updateDetails={HCORequest}
            closePopup={() => {
              setModal(false)
            }}
            open={modal.flag}
            success={modal.success}
            message={modal.message}
            title={modal.title}
            typeHCP={true}
            addNewHCP={true}
            flag={modal.flag}
            close={() => {
              setModal(false)
            }}
            source={data.source}
          />
        )
      }

      {renderConfirmDialog()}

    </div>
  )
}

export default withRouter(AddNewHCOUS)